import { createRoot } from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from "react-cookie";
import App from "./app/App";

async function main() {
  if (process.env.NODE_ENV === 'development' && process.env.MIRAGE_ENV === 'true') {
    const { startMirage } = await import('./mirage/server');
    startMirage();
  }

  const container = document.getElementById("root");
  const root = createRoot(container!);
  root.render(
    <CookiesProvider>
      <App />
    </CookiesProvider>
  );

  reportWebVitals();
}

main();
